import { useCallback, useEffect, useState } from "react";
import ArrowBack from "../../audi-ui-components/icons/Back";
import ArrowForward from "../../audi-ui-components/icons/Forward";

export const usePrevNextButtons = (emblaApi) => {
  const [prevBtnDisabled, setPrevBtnDisabled] = useState(true);
  const [nextBtnDisabled, setNextBtnDisabled] = useState(true);

  const onPrevButtonClick = useCallback(() => {
    if (!emblaApi) return;
    emblaApi.scrollPrev();
  }, [emblaApi]);

  const onNextButtonClick = useCallback(() => {
    if (!emblaApi) return;
    emblaApi.scrollNext();
  }, [emblaApi]);

  const onSelect = useCallback((emblaApi) => {
    setPrevBtnDisabled(!emblaApi.canScrollPrev());
    setNextBtnDisabled(!emblaApi.canScrollNext());
  }, []);

  useEffect(() => {
    if (!emblaApi) return;
    onSelect(emblaApi);
    emblaApi.on('reInit', onSelect).on('select', onSelect);
  }, [emblaApi, onSelect]);

  return {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick
  };
}

export const PrevButton = ({ children, ...restProps}) => {
  return (
    <button
      className="embla__button embla__button--prev"
      type="button"
      {...restProps}
    >
      <ArrowBack large />
      {children}
    </button>
  );
}

export const NextButton = ({ children, ...restProps }) => {
  return (
    <button
      className="embla__button embla__button--next"
      type="button"
      {...restProps}
    >
      <ArrowForward large />
      {children}
    </button>
  );
}
